import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const KEY = "cft_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (prop, rental_days = 1, quantity = 1) => {
    setItems((prev) => {
      const i = prev.findIndex((p) => p.prop_id === prop.id);
      if (i >= 0) {
        const next = [...prev];
        next[i] = { ...next[i], quantity: next[i].quantity + quantity };
        return next;
      }
      return [...prev, {
        prop_id: prop.id, name: prop.name, image: prop.image,
        daily_rate: prop.daily_rate, deposit: prop.deposit || 0,
        quantity, rental_days,
      }];
    });
  };
  const remove = (prop_id) => setItems((p) => p.filter((x) => x.prop_id !== prop_id));
  const update = (prop_id, patch) =>
    setItems((p) => p.map((x) => (x.prop_id === prop_id ? { ...x, ...patch } : x)));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.daily_rate * i.quantity * i.rental_days, 0);
  const deposit = items.reduce((s, i) => s + (i.deposit || 0) * i.quantity, 0);

  return (
    <CartCtx.Provider value={{ items, add, remove, update, clear, subtotal, deposit, total: subtotal + deposit }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
